export default {
  AD: 'Andorra',
  AF: 'Afghanistan',
  EG: 'Ai Cập',
  EH: 'Phía tây Sahara',
  FO: 'quần đảo faroe',
  GA: 'Gabon',
  GD: 'Greneda',
  GI: 'Gibraltar',
  GM: 'Gambia',
  AG: 'Antigua và Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AN: 'Antille thuộc Hà Lan',
  AO: 'Ăng-gô-la',
  AQ: 'Nam Cực',
  AR: 'Argentina',
  AU: 'Châu Úc',
  AW: 'Aruba',
  AZ: 'Azerbaijan',
  BA: 'Bosnia và Herzegovina',
  BB: 'Barbados',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Bénin',
  BM: 'Bermuda',
  BS: 'Bahamas',
  BV: 'Đảo Bouvet',
  BW: 'Botswana',
  BZ: 'Belize',
  CA: 'Canada',
  CF: 'Trung Phi',
  CG: 'Congo',
  CI: 'Bờ Biển Ngà',
  CK: 'Hòn đảo',
  CN: 'Trung Quốc',
  CU: 'cuba',
  CV: 'mũi verde',
  DE: 'nước Đức',
  EC: 'Ecuador',
  GR: 'Hy Lạp',
  IR: 'Iran',
  IT: 'Nước Ý',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Nhật Bản',
  KE: 'Kenya',
  KM: 'Comoros',
  KP: 'Bắc Triều Tiên',
  KR: 'Hàn Quốc',
  LB: 'lebanon',
  LS: 'Lesotho',
  LU: 'Luxembourg',
  LV: 'Latvia',
  MD: 'Moldova',
  GU: 'đảo Guam',
  HK: 'Trung Quốc Hồng Kông',
  HM: 'Quần đảo Heard và McDonald',
  HT: 'Haiti',
  MK: 'Macedonia',
  ML: 'Mali',
  MN: 'Mông Cổ',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Người israel',
  IN: 'Ấn Độ',
  IQ: 'Irắc',
  MT: 'mạch nha',
  MV: 'Maldives',
  MX: 'México',
  NC: 'caledonia mới',
  NI: 'Nicaragua',
  NZ: 'New Zealand',
  PE: 'Peru',
  PL: 'Ba Lan',
  PT: 'Bồ Đào Nha',
  PW: 'Palau',
  CR: 'costa rica',
  CZ: 'Cộng hòa Séc',
  DZ: 'Algérie',
  ET: 'Ethiopia',
  FR: 'Pháp',
  RO: 'Rumani',
  RU: 'Nga',
  SA: 'Ả Rập Saudi',
  SB: 'Quần đảo Solomon',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Thụy Điển',
  SG: 'Singapore',
  SI: 'Slovenia',
  SJ: 'Quần đảo Svalbard và Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SN: 'Sénégal',
  SO: 'somali',
  SR: 'Surinam',
  ST: 'Sao Tome và Principe',
  SV: 'El Salvador',
  SZ: 'Swaziland',
  TC: 'Quần đảo Turks và Caicos',
  TD: 'Tchad',
  TF: 'Lãnh thổ phía Nam của Pháp',
  TG: 'đi',
  TH: 'nước Thái Lan',
  TK: 'Tokelau',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TP: 'Đông Timor',
  TT: 'Trinidad và Tobago',
  UA: 'Ukraina',
  US: 'Hoa Kỳ',
  UZ: 'Uzbekistan',
  VA: 'Vatican',
  VE: 'Venezuela',
  VG: 'Quần đảo Virgin thuộc Anh',
  VU: 'Vanuatu',
  YE: 'Yêmen',
  YT: 'mayotte',
  YU: 'Nam Tư',
  ZA: 'Nam Phi',
  ZW: 'Zimbabwe',
  GB: 'Vương quốc Anh',
  BO: 'Bôlivia',
  BT: 'Bhutan',
  BY: 'Bêlarut',
  CC: 'Quần đảo Cocos (Keeling)',
  CL: 'Chilê',
  CO: 'Colombia',
  TW: 'Đài Loan, Trung Quốc',
  CY: 'Síp',
  DK: 'Đan mạch',
  DO: 'Cộng hòa Dominica',
  ES: 'Tây ban nha',
  FI: 'Phần Lan',
  FK: 'Malvinas (Quần đảo Falkland)',
  GE: 'bang Georgia',
  GL: 'Greenland',
  GN: 'Ghi-nê',
  GS: 'Quần đảo Nam Georgia và Nam Sandwich',
  KW: 'Cô-oét',
  KZ: 'Kazakhstan',
  LT: 'Litva',
  LY: 'Lybia',
  MH: 'đảo Marshall',
  MO: 'Ma-cao, Trung Quốc',
  MU: 'Mô-ri-xơ',
  MY: 'Malaysia',
  NA: 'Namibia',
  NU: 'Niue',
  OM: 'Ô-man',
  PK: 'Pakistan',
  PR: 'Puerto Rico',
  AT: 'Áo',
  BD: 'Bangladesh',
  CH: 'Thụy sĩ',
  CS: 'đảo giáng sinh',
  FM: 'Micronesia',
  IO: 'Lãnh thổ Ấn Độ Dương thuộc Anh',
  KI: 'Kiribati',
  LC: 'thánh lucia',
  MA: 'Ma-rốc',
  MM: 'Myanmar',
  MS: 'Montserrat',
  NG: 'Nigeria',
  PH: 'Philippines',
  RE: 'Đoàn tụ',
  WS: 'Tây Samoa',
  AE: 'các Tiểu Vương Quốc Ả Rập Thống Nhất',
  AS: 'American Samoa',
  BE: 'nước Bỉ',
  BN: 'Vương quốc Bru-nây',
  CM: 'Ca-mơ-run',
  DJ: 'Djibouti',
  ER: 'Eritrea',
  GF: 'Guiana thuộc Pháp',
  GW: 'Guiné-Bissau',
  HR: 'Croatia',
  IS: 'Nước Iceland',
  KH: 'Campuchia',
  KY: 'Quần đảo Cayman',
  LR: 'Liberia',
  MQ: 'Martinique',
  MZ: 'Mozambique',
  PA: 'Panama',
  PN: 'Nhóm Quần đảo Pitcairn',
  RW: 'Rwanda',
  SH: 'thánh Helena',
  SM: 'thánh Marion',
  SY: 'Syria',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  EE: 'Estonia',
  LI: 'Liechtenstein',
  NF: 'Đảo Norfolk',
  PY: 'Paraguay',
  GP: 'Guadeloupe',
  UM: 'Ủy ban linh tinh của Mỹ',
  NP: 'Nepal',
  PM: 'Thánh Pierre và Miquelon',
  GQ: 'Equatorial Guinea',
  GY: 'Guyana',
  KG: 'Kyrgyzstan',
  KN: 'Saint Kitts và Nevis',
  LA: 'Nước Lào',
  LK: 'Sri Lanka',
  MC: 'Monaco',
  MG: 'Madagascar',
  MR: 'Mauritanie',
  MW: 'Malawi',
  NE: 'Niger',
  NO: 'Na Uy',
  NR: 'Nauru',
  PG: 'papua new guinea',
  PS: 'Palestine',
  QA: 'Qatar',
  RS: 'Serbia',
  MP: 'Quần đảo Bắc Mariana',
  NL: 'nước Hà Lan',
  PF: 'Polynesia thuộc Pháp',
  AM: 'Armenia',
  BR: 'Brazil',
  DM: 'Dominica',
  HN: 'Honduras',
  TO: 'Tonga',
  TR: 'Thổ Nhĩ Kỳ',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UY: 'Uruguay',
  VC: 'Saint Vincent và Grenadines',
  VI: 'Quần đảo Virgin thuộc Hoa Kỳ',
  WF: 'quần đảo wallis và futuna',
  ZM: 'Zambia',
  FJ: 'Fiji',
  GH: 'Ghana',
  GT: 'Guatemala',
  VN: 'Việt Nam',
  ZR: 'Zaire',
};
